import {createSlice} from '@reduxjs/toolkit';
import {configureTransport} from '../../api/transport';

export const adaptiveSlice = createSlice({
    name: 'adaptive',
    initialState: {
        isMob: false
    },
    reducers: {
        setIsMob: (state, action) => {
            state.isMob = action.payload;
        },
    },
});

export const {setIsMob} = adaptiveSlice.actions;

export default adaptiveSlice.reducer;
